import { AggregateWorkedTimeBlocksFilter } from 'modules/attendance/store/models/AggregateWorkedTimeFilter'

export const getBalanceAccruedMinutes = (
  filteredWorkedTimeBlocks: AggregateWorkedTimeBlocksFilter,
  estimatedMinutesUntilDate: number
) => {
  const regularMinutes = filteredWorkedTimeBlocks.regular.minutes
  const approvedOvertimeBalanceMinutes =
    filteredWorkedTimeBlocks.approved.overtime.withBalancePoolType.minutes

  return Math.max(regularMinutes + approvedOvertimeBalanceMinutes - estimatedMinutesUntilDate, 0)
}
